// src/utils/dialogRenderer.js
import { h, createApp, ref } from 'vue';
import ObDialog from '@/components/common/obDialog.vue';

let dialogApp = null;
let dialogContainer = null;

export function renderDialog(props) {
  unmountDialog()
  // 使用 h 函数渲染组件
  const dialogVNode = h(ObDialog, props);

  // 创建独立的 Vue 应用
  dialogApp = createApp({
    render: () => dialogVNode
  });

  // 挂载到 DOM
  dialogContainer = document.createElement('div');
  document.body.appendChild(dialogContainer);
  dialogApp.mount(dialogContainer);
}

export function unmountDialog() {
  if (dialogApp) {
    dialogApp.unmount();
    if (dialogContainer && dialogContainer.parentNode) {
      dialogContainer.parentNode.removeChild(dialogContainer);
    }
    dialogApp = null;
    dialogContainer = null;
  }
}